export enum OrderBookBadgeValueType {
  ORDER_PRODUCTS = 'ORDER_PRODUCTS',
  PIECES = 'PIECES',
}
